(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elmore-offer-badges"] && !Shopify.designMode) return;
  try {
    const roots=document.querySelectorAll('[data-en-pdp-offers]');
const update=(root)=>{
  let map={};try{map=JSON.parse(root.querySelector('[data-en-pdp-offer-map]')?.textContent||'{}')}catch(e){}
  const productDetails=root.closest('.product-details')||document;
  const id=productDetails.querySelector('input[name="id"]')?.value||root.dataset.selectedVariant;
  const state=map[id]||{};
  const type=state.b2g1?'b2g1':state.b1g1?'b1g1':'';
  const chip=root.querySelector('[data-en-pdp-offer-chip]');
  const progress=root.querySelector('[data-en-pdp-offer-progress]');
  if(!chip||!progress)return;
  chip.hidden=!type;progress.hidden=!type;
  if(!type)return;
  chip.textContent=type==='b2g1'?'BUY 2 GET 1 FREE':'BUY 1 GET 1 FREE';
  const qty=Math.max(1,Number(productDetails.querySelector('input[name="quantity"]')?.value||1));
  const buy=type==='b2g1'?2:1;
  const freebies=Math.floor(qty/buy);
  const remainder=qty%buy;
  const fill=root.querySelector('[data-en-pdp-offer-fill]');
  const message=root.querySelector('[data-en-pdp-offer-message]');
  if(fill)fill.style.width=(type==='b1g1'?100:(remainder===0?100:Math.round(remainder/buy*100)))+'%';
  if(message){
    if(freebies>0)message.textContent=freebies+' FREE unlocked';
    else message.textContent='Add '+(buy-remainder)+' more → unlock 1 FREE';
  }
};
roots.forEach((root)=>{update(root);root.closest('.product-details')?.addEventListener('change',()=>update(root));});
document.addEventListener('shopify:product:select',()=>setTimeout(()=>roots.forEach(update),40));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["elmore-pdp-smart-actions"] && !Shopify.designMode) return;
  try {
    (function(){
  const root=document.currentScript?.closest('.shopify-block')?.querySelector('[data-en26-smart-actions]')||document.querySelector('[data-en26-smart-actions]');
  if(!root||root.dataset.ready==='1')return;root.dataset.ready='1';
  const dialog=root.querySelector('[data-en26-dialog]');
  const tabs=[...root.querySelectorAll('[data-en26-tab]')];
  const panels=[...root.querySelectorAll('[data-en26-panel]')];
  const usageVideo=root.querySelector('[data-en26-panel="video"] video');
  const sizeVideoDialog=()=>{
    if(!usageVideo||!usageVideo.videoWidth||!usageVideo.videoHeight)return;
    const ratio=usageVideo.videoWidth/usageVideo.videoHeight;
    const maxH=Math.min(window.innerHeight*.68,720);
    const natural=Math.min(usageVideo.videoWidth,900);
    const width=Math.max(280,Math.min(window.innerWidth-20,natural,maxH*ratio+44));
    dialog?.style.setProperty('--en26-video-dialog-width',Math.round(width)+'px');
  };
  usageVideo?.addEventListener('loadedmetadata',sizeVideoDialog);
  const setTab=(name)=>{
    tabs.forEach(b=>{const on=b.dataset.en26Tab===name;b.classList.toggle('is-active',on);b.setAttribute('aria-selected',on?'true':'false')});
    panels.forEach(p=>p.hidden=p.dataset.en26Panel!==name);
    dialog?.classList.toggle('is-video',name==='video');
    if(name==='video')requestAnimationFrame(sizeVideoDialog);
    else requestAnimationFrame(()=>fitSmartPanel(name));
  };
  const fitSmartPanel=(name)=>{
    if(!dialog||!dialog.open)return;
    const panel=root.querySelector('[data-en26-panel="'+name+'"]');
    if(!panel)return;
    const vh=Math.max(320,window.innerHeight||document.documentElement.clientHeight||800);
    dialog.style.setProperty('--en26-smart-vh',vh+'px');
  };
  let en26FitFrame=0;
  const refitSmart=()=>{cancelAnimationFrame(en26FitFrame);en26FitFrame=requestAnimationFrame(()=>{const active=tabs.find(b=>b.classList.contains('is-active'));if(active)fitSmartPanel(active.dataset.en26Tab)});};
  window.addEventListener('resize',refitSmart,{passive:true});
  root.querySelectorAll('[data-en26-open]').forEach(b=>b.addEventListener('click',()=>{const name=b.dataset.en26Open;setTab(name);if(!dialog.open){try{dialog.showModal()}catch(e){dialog.setAttribute('open','')}}if(name!=='video')requestAnimationFrame(()=>fitSmartPanel(name));}));
  tabs.forEach(b=>b.addEventListener('click',()=>setTab(b.dataset.en26Tab)));
  root.querySelector('[data-en26-close]')?.addEventListener('click',()=>dialog.close());

  const compare=root.querySelector('[data-en26-compare]');
  const compareRange=root.querySelector('[data-en26-compare-range]');
  const compareAfter=root.querySelector('[data-en26-after-wrap]');
  const compareHandle=root.querySelector('[data-en26-compare-handle]');
  const setCompare=(value)=>{const v=Math.max(0,Math.min(100,Number(value)||50));if(compareAfter)compareAfter.style.clipPath='inset(0 '+(100-v)+'% 0 0)';if(compareHandle)compareHandle.style.left=v+'%';if(compareRange)compareRange.value=String(v)};
  compareRange?.addEventListener('input',()=>setCompare(compareRange.value));
  compare?.addEventListener('pointermove',(e)=>{if(e.pointerType!=='mouse')return;const r=compare.getBoundingClientRect();setCompare(((e.clientX-r.left)/r.width)*100)});

  const cameraChoice=root.querySelector('[data-en26-camera-choice]');
  const uploadChoice=root.querySelector('[data-en26-upload-choice]');
  const cameraInput=root.querySelector('[data-en26-camera-input]');
  const fileInput=root.querySelector('[data-en26-file-input]');
  const cameraStage=root.querySelector('[data-en26-camera-stage]');
  const liveVideo=root.querySelector('[data-en26-camera-live]');
  const canvas=root.querySelector('[data-en26-camera-canvas]');
  const captureBtn=root.querySelector('[data-en26-camera-capture]');
  const cancelBtn=root.querySelector('[data-en26-camera-cancel]');
  const confirmBox=root.querySelector('[data-en26-confirm]');
  const confirmYes=root.querySelector('[data-en26-confirm-yes]');
  const confirmRetake=root.querySelector('[data-en26-confirm-retake]');
  const preview=root.querySelector('[data-en26-preview]');
  const result=root.querySelector('[data-en26-photo-result]');
  const loading=root.querySelector('[data-en26-loading]');
  const loadingTitle=root.querySelector('[data-en26-loading-title]');
  const loadingCopy=root.querySelector('[data-en26-loading-copy]');
  let stream=null,currentFile=null,currentUrl='';
  const stopCamera=()=>{stream?.getTracks?.().forEach(t=>t.stop());stream=null;if(liveVideo)liveVideo.srcObject=null;if(cameraStage)cameraStage.hidden=true};
  const showCandidate=(file,label='Photo ready')=>{if(!file||!preview)return;currentFile=file;if(currentUrl)URL.revokeObjectURL(currentUrl);currentUrl=URL.createObjectURL(file);preview.hidden=false;preview.innerHTML='<img src="'+currentUrl+'" alt="Photo preview"><div><b>'+label+'</b><small>Check the photo, then choose whether Elmore should review the visible concern.</small></div>';if(confirmBox)confirmBox.hidden=false;if(result)result.hidden=true};
  const startCamera=async()=>{
    if(!navigator.mediaDevices?.getUserMedia){cameraInput?.click();return}
    try{stopCamera();stream=await navigator.mediaDevices.getUserMedia({video:{facingMode:{ideal:'environment'},width:{ideal:1280},height:{ideal:1280}},audio:false});if(liveVideo){liveVideo.srcObject=stream;await liveVideo.play()}if(cameraStage)cameraStage.hidden=false;if(confirmBox)confirmBox.hidden=true}
    catch(e){cameraInput?.click()}
  };
  cameraChoice?.addEventListener('click',startCamera);
  uploadChoice?.addEventListener('click',()=>fileInput?.click());
  cancelBtn?.addEventListener('click',stopCamera);
  captureBtn?.addEventListener('click',()=>{if(!liveVideo||!canvas||!liveVideo.videoWidth)return;canvas.width=liveVideo.videoWidth;canvas.height=liveVideo.videoHeight;canvas.getContext('2d').drawImage(liveVideo,0,0,canvas.width,canvas.height);canvas.toBlob(blob=>{if(!blob)return;stopCamera();showCandidate(new File([blob],'elmore-camera.jpg',{type:'image/jpeg'}),'Fresh shot ready')},'image/jpeg',.9)});
  cameraInput?.addEventListener('change',()=>showCandidate(cameraInput.files?.[0],'Fresh shot ready'));
  fileInput?.addEventListener('change',()=>showCandidate(fileInput.files?.[0],'Upload ready'));
  confirmRetake?.addEventListener('click',()=>{if(confirmBox)confirmBox.hidden=true;startCamera()});
  dialog?.addEventListener('close',stopCamera);

  const sleep=(ms)=>new Promise(resolve=>setTimeout(resolve,ms));
  const showLoading=()=>{if(result)result.hidden=true;if(confirmBox)confirmBox.hidden=true;if(loading){loading.hidden=false;loading.classList.add('is-active')}};
  const hideLoading=()=>{if(loading){loading.hidden=true;loading.classList.remove('is-active')}};
  const renderFallback=()=>{if(!result)return;result.hidden=false;result.innerHTML='<b>Product-fit guidance</b><p>Your photo is ready, but the secure Elmore AI photo-analysis service is not responding right now. We will not fake a visual diagnosis.</p><p><strong>This product is designed around:</strong> '+(root.dataset.concern||'the concern described above')+'.</p>'};
  const runAnalysis=async(file)=>{
    if(!file||!result)return;showLoading();if(loadingTitle)loadingTitle.textContent='Checking the visible concern…';if(loadingCopy)loadingCopy.textContent='Matching what is visible in the photo with this product — no fake diagnosis.';
    const fd=new FormData();fd.append('image',file);fd.append('product_id',root.dataset.productId||'');fd.append('product_handle',root.dataset.productHandle||'');fd.append('product_title',root.dataset.productTitle||'');fd.append('concern',root.dataset.concern||'');fd.append('skin_type',root.dataset.skin||'');
    try{const started=Date.now();const res=await fetch('/apps/elmore-ai/product-fit',{method:'POST',body:fd,headers:{Accept:'application/json'}});const elapsed=Date.now()-started;if(elapsed<850)await sleep(850-elapsed);if(!res.ok)throw new Error('AI endpoint unavailable');const data=await res.json();hideLoading();result.hidden=false;result.innerHTML='<span class="en26-fit-badge">'+(data.fit_label||'Product fit guidance')+'</span><h6>'+(data.summary||'')+'</h6>'+(data.why?'<p>'+data.why+'</p>':'')+(data.routine?'<div class="en26-fit-box"><b>Routine</b><p>'+data.routine+'</p></div>':'')+(data.recommendation?'<div class="en26-fit-box"><b>You may prefer</b><p>'+data.recommendation+'</p></div>':'')}catch(e){await sleep(450);hideLoading();renderFallback()}
  };
  confirmYes?.addEventListener('click',()=>runAnalysis(currentFile));
})();
  } catch(e) { console.error(e); }
})();

})();
